import { ResolvedNavItem } from '../interfaces';

const getActiveKeys = (items: ResolvedNavItem[]): string[] => {
    return items.reduce<string[]>((acc, item) => {
        if (item.isActive || item.children?.some(child => child.isActive)) {
            acc.push(item.id);
        }

        return acc;
    }, []);
};

export default getActiveKeys;
